import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Benefits from "../pages/benefits/page";
import Steps from "../pages/steps/page";
import MoodMatch from "../pages/mood-match/page";
import DailyWisdom from "../pages/daily-wisdom/page";
import ForestBathing from "../pages/forest-bathing/page";
import About from "../pages/about/page";
import BlogList from "../pages/blog/page";
import BlogArticle from "../pages/blog/article/page";
import PrivacyPolicy from "../pages/privacy/page";
import ContactUs from "../pages/contact/page";
import TermsOfUse from "../pages/terms/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/benefits", element: <Benefits /> },
  { path: "/steps", element: <Steps /> },
  { path: "/mood-match", element: <MoodMatch /> },
  { path: "/daily-wisdom", element: <DailyWisdom /> },
  { path: "/forest-bathing", element: <ForestBathing /> },
  { path: "/about", element: <About /> },
  { path: "/blog", element: <BlogList /> },
  { path: "/blog/:slug", element: <BlogArticle /> },
  { path: "/privacy", element: <PrivacyPolicy /> },
  { path: "/contact", element: <ContactUs /> },
  { path: "/terms", element: <TermsOfUse /> },
  { path: "*", element: <NotFound /> },
];

export default routes;